import getTimeInHMSFormat from '@utils/getTimeInHMSFormat';

const isNumeric = (num) => {
  return !isNaN(num);
};

export default (data) => {
  if (isNumeric(data)) {
    if (data < 0) {
      return `${data}s`;
    }
    const milliseconds = Number(data);
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    seconds = seconds % 60;
    minutes = minutes % 60;
    return getTimeInHMSFormat(hours, minutes, seconds);
  } else {
    return '-';
  }
};
